module.exports = __webpack_public_path__ + "img/proveedores.eefd3f98.svg";